import React from "react";
import './current-goods.scss'
import showPrice from "utils/show-price";
import {getGoodsType} from "../../../../../../utils/GoodsTypeUtil";

const CurrentGoods = ({goods, toGoodsInfo}) => {

    const {isPddShop, isJdShop} = goods;

    const goodsType = getGoodsType({isPddShop, isJdShop});

    return (
        <div className="glx-live-room__current-goods">
            <div className="title-container">
                <div className="title">直播中的商品</div>
            </div>
            <div className="img-container">
                <img src={goods.mainPic} alt="" className="img"/>
            </div>
            <div className="info-container">
                <div className="price">{showPrice(goods.currentPrice)}</div>
                <div className="buy" onClick={() => toGoodsInfo({id: goods.goodsId, goodsType})}>去买</div>
            </div>
        </div>
    )
}

export default CurrentGoods;